import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { INSTALLER_OFFER_OID } from '../../shared/injectionTokens';
import { BobHttpService } from '../../shared/services/bob-http.service';

import { LegalDocumentUserApproval } from './api/GetApprovedDocumentApiResult';
import { LegalDocument } from './api/GetToApproveDocumentApiResult';
import { LegalDocumentGateway } from './LegalDocumentGateway';

const LEGAL_DOCUMENT_ENDPOINT = '/legaldocs-api/public/v1';

@Injectable()
export class HttpLegalDocumentGateway implements LegalDocumentGateway {
    constructor(
        protected http: BobHttpService,
        @Inject(INSTALLER_OFFER_OID) private offerOID: string,
    ) {}

    getApprovals(countryCode: string): Observable<LegalDocumentUserApproval[]> {
        const params = this.getRequestParams(countryCode);
        return this.http
            .get(`${LEGAL_DOCUMENT_ENDPOINT}/userapproval/documents/approved`, params)
            .pipe(map((bobResponse) => bobResponse.results));
    }

    getDocumentToApprove(countryCode: string): Observable<LegalDocument[]> {
        const params = this.getRequestParams(countryCode);
        return this.http
            .get(`${LEGAL_DOCUMENT_ENDPOINT}/userapproval/documents/toapprove`, params)
            .pipe(map((result) => result.results));
    }

    approveLegalDocuments(countryCode: string): Observable<void> {
        const params = this.getRequestParams(countryCode);
        const body = {
            signatureType: 'simple',
        };

        return this.http.post(`${LEGAL_DOCUMENT_ENDPOINT}/userapproval/documents/approve`, body, params);
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private getRequestParams(countryCode: string): any {
        return { offerOID: this.offerOID, countryCode };
    }
}
